module.exports = __webpack_public_path__ + "static/img/8-info.23a6e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/8-info.png
// module id = rEMT
// module chunks = 0